<div class="fw-bold bg-white p-3 rounded-5 mb-5">
    <div class="row mt-3">
      <div class="col">
        <label for="information" class="labelInformation">{{ information }}</label>
      </div>
      <div class="col btn-back text-end">
        <button class="btn btn-secondary" (click)="goBack()">Back</button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <label for="customerName">Distributor name<span class="required">*</span></label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="customerName" [readonly]="!permissionsService.editPermission" />
      </div>
      <div class="col">
        <label for="address">Address</label>
        <input type="text" style="display:none" />
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="address" [readonly]="!permissionsService.editPermission" />
      </div>
      <div class="col">
        <label for="customerCity">City</label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="city" [readonly]="!permissionsService.editPermission" />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <label for="state" class="input-label">State</label>
        <select class="form-select input-label" [(ngModel)]="stateSelected" (change)="checkFields()" [disabled]="!permissionsService.editPermission">
          <option value="">Select Value</option>
          <option *ngFor="let option of states" [value]="option.aValue">{{ option.aDescription }}</option>
        </select>
      </div>
      <div class="col">
        <label for="zipCode">ZIP code</label>
        <input type="number" class="form-control input-label" (input)="checkFields()" [(ngModel)]="zipCode" [readonly]="!permissionsService.editPermission" />
      </div>
      <div class="col">
        <label for="contactNumber">Contact number<span class="required">*</span></label>
        <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="contactNumber" appFormatPhoneUs [readonly]="!permissionsService.editPermission" />
      </div>
    </div>

    <form [formGroup]="form">
      <div class="row mt-3">
        <div class="col-4">
          <label for="email">Email<span class="required">*</span></label>
          <input type="email" class="form-control input-label" formControlName="email"
            [(ngModel)]="email" name="email" (change)="checkEmailValidity()" (input)="checkFields()" appFormatEmail [readonly]="!permissionsService.editPermission" />
          <div *ngIf="emailModel?.errors?.['emailInvalid']">Email is not valid</div>
        </div>
      </div>
    </form>

    <div class="row mt-3">
      <div class="col text-end">
        <button class="btn btn-primary" [disabled]="!fieldsCompleted || !permissionsService.editPermission" (click)="updateCustomer()">
          Save distributor info
        </button>
      </div>
    </div>
</div>
